import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { AppLinksService } from '../../api/services/app-links.service';
import { BusinessAccountCtaComponent } from '../../partials/components/business-account-cta/business-account-cta.component';
import {
  RelatedPage,
  RelatedPagesComponent,
} from '../../partials/components/related-pages/related-pages.component';

@Component({
  selector: 'app-aml-api',
  imports: [MatIcon, RouterLink, BusinessAccountCtaComponent, RelatedPagesComponent],
  templateUrl: './aml-api.component.html',
  styleUrl: './aml-api.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AmlApiComponent {
  protected readonly appLinks = inject(AppLinksService);

  protected readonly relatedPages: RelatedPage[] = [
    {
      link: '/aml-check',
      anchor: 'Online AML check in the dashboard',
      text: 'Try the same checks by hand before you write a line of integration code.',
    },
    {
      link: '/transaction-monitoring',
      anchor: 'Crypto transaction monitoring',
      text: 'Keep the wallets your integration submits under continuous watch, with alerts for your team.',
    },
    {
      link: '/solutions/payment-provider',
      anchor: "AML for payment providers",
      text: "The same integration seen from a PSP: screening a payer inside your own payment flow, on behalf of a merchant.",
    },
    {
      link: '/pricing',
      anchor: 'Pricing and plans',
      text: 'Pro, Corporate and Enterprise plans, each with all four AML providers through one integration; per-report rates appear in your account after registration.',
    },
  ];
}
